var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ClientSelector"},[_c('SelectorMultiple',{attrs:{"select-label":"Cliente","select-form-options":_vm.options,"selectedClients":this.clients},on:{"handlerSelect":_vm.getSelectedClients}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }